module.exports = [{
      plugin: require('/codebuild/output/src933853165/src/appenzellerdialekt/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/codebuild/output/src933853165/src/appenzellerdialekt/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-137340827-1","anonymize":true,"respectDNT":true},
    }]
